<template>
  <v-card class="mx-auto text-center">
    <v-row>
      <v-col>
        <v-sheet height="650" width="1200">
          <v-calendar
            ref="calendar"
            :now="today"
            :value="today"
            :events="events"
            color="primary"
            type="week"
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "Calendar",
  data: () => ({
    today: "2020-10-15",
    events: [
      {
        name: "Weekly Meeting",
        start: "2020-10-15 09:00",
        end: "2020-10-15 11:00"
      },
      {
        name: "Campaign Launch",
        start: "2020-10-15"
      },
      {
        name: "Project Landmark Review",
        start: "2020-10-15 12:30",
        end: "2020-10-15 15:30"
      }
    ]
  }),
  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
  }
};
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}
.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
</style>
